import React, {
  forwardRef,
  useImperativeHandle,
} from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import { isEmpty } from 'lodash'

import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Input from '@material-ui/core/Input'
import FormControl from '@material-ui/core/FormControl'

import makeStyles from '@material-ui/core/styles/makeStyles'

import { usePrice } from '../../../../../shared/contexts/PriceContext'

import {
  ButtonLight,
  ButtonGradient,
} from '../../../../../shared/components'

import CollapsePrice from '../../../../../shared/components/CollapsePrice/CollapsePrice'

import useUserClient from '../../../../../clients/UserClient/useUserClient'

const useStyles = makeStyles((theme) => ({
  buttonsStep: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& .MuiBox-root': {
      minWidth: 190,
      [theme.breakpoints.down('xs')]: {
        marginTop: 5,
        marginLeft: 5,
        minWidth: 115,
      },
    },
  },
  label: {
    color: theme.palette.text.quaternary,
    fontWeight: 'bold',
  },
}))

const PolicyHolderClaimant = forwardRef((props, ref) => {
  const classes = useStyles()
  const userClient = useUserClient()
  const { state } = useLocation()

  const {
    quote,
    checked,
    handleStep,
    handleNext,
    handlePrevious,
  } = props

  const {
    onNext,
    actionNext,
    judicialGuaranteeAppeal,
    setJudicialGuaranteeAppeal,
  } = usePrice()

  const tomadorName = quote?.PolicyHolderClaimant?.PolicyHolder
    ?? state?.tomadorName ?? ''
  const tomadorDocument = quote?.PolicyHolderClaimant?.Document
    ?? state?.tomadorDocument ?? ''

  useImperativeHandle(ref, () => ({
    onSubmit: () => new Promise((resolve) => {
      const values = {
        ...judicialGuaranteeAppeal,
        policyHolderClaimant: {
          policyHolder: tomadorName,
          document: tomadorDocument,
        },
      }

      userClient().getClientByUserLogged().then((response) => {
        const filterNotLead = response?.data?.filter((item) => item?.lead === false)
        const filterNomination = filterNotLead
          ?.filter((item) => item?.cpfcnpj === values.policyHolderClaimant.document)
        if (filterNomination?.length > 0) {
          setJudicialGuaranteeAppeal({ ...values, ClientIsNominated: true })
        } else {
          setJudicialGuaranteeAppeal({ ...values, ClientIsNominated: false })
        }
      }, () => {
        setJudicialGuaranteeAppeal({ ...values })
      })

      if (actionNext) {
        onNext(values)
      }

      resolve(undefined)
    }),
  }))

  const policyHolderLabel = 'Tomador'
  const cpfCnpjLabel = 'CPF/CNPJ'

  return (
    <>
      <CollapsePrice
        checked={checked}
        handleEdit={handleStep}
        hiddenEdit={isEmpty(quote?.PolicyHolderClaimant)}
        title="Tomador"
        subtitle="Caso queira alterar o tomador, retorne à etapa de Dados do Produto"
      >
        <Grid container spacing={5}>
          <Grid item sm={6} xs={12}>
            <FormControl fullWidth>
              <label htmlFor="policyHolderLabel" className={classes.label}>
                {policyHolderLabel}
              </label>
              <Input
                fullWidth
                id="policyHolder"
                color="secondary"
                disabled
                value={tomadorName}
              />
            </FormControl>
          </Grid>
          <Grid item sm={6} xs={12}>
            <FormControl fullWidth>
              <label htmlFor="cpfCnpjLabel" className={classes.label}>
                {cpfCnpjLabel}
              </label>
              <Input
                fullWidth
                id="document"
                color="secondary"
                disabled
                value={tomadorDocument}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Box className={classes.buttonsStep}>
              <Box>
                <ButtonLight
                  onClick={handlePrevious}
                  title="Voltar"
                >
                  Voltar
                </ButtonLight>
              </Box>
              <Box ml={4}>
                <ButtonGradient
                  onClick={handleNext}
                  title="Continuar"
                >
                  Continuar
                </ButtonGradient>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </CollapsePrice>
    </>
  )
})

PolicyHolderClaimant.propTypes = {
  quote: PropTypes.any,
  checked: PropTypes.bool,
  handleStep: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  handlePrevious: PropTypes.func.isRequired,
}

PolicyHolderClaimant.defaultProps = {
  checked: false,
  quote: undefined,
}

export default PolicyHolderClaimant
